import axios from 'axios';
import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import { Organisation, User } from '@/models/User';

axios.defaults.baseURL = process.env.VUE_APP_API_URL;

@Module({ namespaced: true })
class OrganisationModule extends VuexModule {
    _organisation: Organisation | null = null;
    _owner: User | null = null;

    get organisation(): Organisation | null {
        return this._organisation;
    }

    get owner(): User | null {
        return this._owner;
    }

    get isOwner(): boolean | undefined {
        if (this._owner && this._organisation) {
            return this._owner.uri === this._organisation.ownerUri;
        }
    }

    @Mutation
    set(organisation: Organisation) {
        this._organisation = organisation;
    }

    @Mutation
    setOwner(account: User) {
        this._owner = account;
    }

    @Action
    async init(account: User) {
        this.context.commit('setOwner', account);

        for (const ref of account.organisations) {
            const r = await axios({
                method: 'GET',
                url: ref,
            });
            const organisation = new Organisation(r.data);

            this.context.commit('set', organisation);
        }
    }

    @Action
    async update(org: Organisation, data: any) {
        const r = await axios({
            method: 'PUT',
            url: `/api/organisations/${org.id}`,
            data,
        });

        return this.context.commit('set', r.data);
    }
}

export default OrganisationModule;
